export const emis = {
  layout: 'aside',
  // asideBlocks: [
  //   { 
  //     component: 'AsideInfoBlock',
  //     props: 'faqs'
  //   }
  // ],
  // mainBlocks: [
  //   {
  //     component: 'PageTitle',
  //     props: 'pageTitle'
  //   },
  //   {
  //     component: 'PageTabsBlock',
  //     props: 'pageTabs'
  //   }
  // ],
  faqs: {
      blockTitle: "FAQs",
      cards: [
        {
          expanded: false,
          title: "Lorem ipsum dolor sit amet, consect adipiscing elit?",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac euismod ipsum, ut consectetur lorem. Mauris id nunc odio. Sed vitae turpis lorem."
        },
        {
          expanded: false,
          title: "Lorem ipsum dolor sit amet, consect adipiscing elit?",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac euismod ipsum, ut consectetur lorem. Mauris id nunc odio. Sed vitae turpis lorem."
        },
        {
          expanded: false,
          title: "Lorem ipsum dolor sit amet, consect adipiscing elit?",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac euismod ipsum, ut consectetur lorem. Mauris id nunc odio. Sed vitae turpis lorem."
        },
        {
          expanded: false,
          title: "Lorem ipsum dolor sit amet, consect adipiscing elit?",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac euismod ipsum, ut consectetur lorem. Mauris id nunc odio. Sed vitae turpis lorem."
        },
        {
          expanded: false,
          title: "Lorem ipsum dolor sit amet, consect adipiscing elit?",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac euismod ipsum, ut consectetur lorem. Mauris id nunc odio. Sed vitae turpis lorem."
        },
        {
          expanded: false,
          title: "Lorem ipsum dolor sit amet, consect adipiscing elit?",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac euismod ipsum, ut consectetur lorem. Mauris id nunc odio. Sed vitae turpis lorem."
        }
      ]
  },
  pageTitle: {
    img: 'emis-icon.png',
    title: 'EMIS',
    text: '<p>You will find the training material as documents or videos in the respective sections below.</p><p>Please browse the list of FAQs on the right. If you still have any questions, please use the \'Query\' section to submit a request to the Digital support team.</p>'
  },
  video: [
      {
        id: "videoid1",
        videoUrl: 'https://www.youtube.com/watch?v=KSM0lLbVYOo',
        title: 'Optimising your EMIS Web configurations',
        date: '07 Sep 2020'
      },
      {
        id: "videoid2",
        videoUrl: 'https://www.youtube.com/watch?v=7E0fVfectDo',
        title: 'Optimising your EMIS Web configurations',
        date: '07 Sep 2020'
      },
      {
        id: "videoid3",
        videoUrl: 'https://www.youtube.com/watch?v=nhDdn86AoXs',
        title: 'Optimising your EMIS Web configurations',
        date: '07 Sep 2020'
      },
      {
        id: "videoid4",
        videoUrl: 'https://www.youtube.com/watch?v=W85oD8FEF78',
        title: 'Optimising your EMIS Web configurations',
        date: '07 Sep 2020'
      },
      {
        id: "videoid5",
        videoUrl: 'https://www.youtube.com/watch?v=NpKpCeUQx2w',
        title: 'Optimising your EMIS Web configurations',
        date: '07 Sep 2020'
      },
      {
        id: "videoid6",
        videoUrl: 'https://www.youtube.com/watch?v=kUubW5szdwA',
        title: 'Optimising your EMIS Web configurations',
        date: '07 Sep 2020'
      },
      {
        id: "videoid7",
        videoUrl: 'https://www.youtube.com/watch?v=DXP1KdZX4io',
        title: 'Optimising your EMIS Web configurations',
        date: '07 Sep 2020'
      },
      {
        id: "videoid8",
        videoUrl: 'https://www.youtube.com/watch?v=Q0oIoR9mLwc',
        title: 'Optimising your EMIS Web configurations',
        date: '07 Sep 2020'
      }
  ],
  queryForm: {
    formProps: {
      thank: 'Thank You',
      title: 'Ask a Question',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac euismod ipsum, ut consectetur lorem. Mauris id nunc odio. Sed vitae turpis lorem. Pellentesque et purus ac tortor aliquam sollicitudin. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Nunc non tempus risus.'
    }
  }, 
  pageTabs: {
    featuresNav: true,
    tabItems: [
      {
        name: 'document',
        title: 'Document',
        icon: 'document-icon-blue.svg',
        iconActive: 'document-icon-white.svg' 
      },
      {
        name: 'video',
        title: 'Video',
        icon: 'play-btn-blue.svg',
        iconActive: 'play-btn.svg'
      },
      {
        name: 'query',
        title: 'Query',
        icon: 'query-icon-blue.svg',
        iconActive: 'query-icon-white.svg'
      }
    ]
  }
}